export const Languages = ["en", "de"] as const;

export const fallbackLanguage = "en";